import { IActivityItem } from '@/components/pages/Activity/interfaces'

import { queryClient } from '@/lib/queryClient'

import { QueryKeys } from '@/enums'

import { getReactionActivityId } from '../getReactionActivityId'

export type OwnReaction =
  | IActivityItem['own_reactions']['like'][number]
  | Record<string, unknown>

export type CachedReaction = {
  reactionsCount: number
  ownReactions: OwnReaction[]
  isLoading: boolean
}

export const cacheActivitiesReactions = (activities: IActivityItem[]) => {
  activities?.forEach((activity) => {
    const reactionActivityId = getReactionActivityId(activity)
    const queryKey = [QueryKeys.Reaction, reactionActivityId]

    const reactionsCount =
      activity.startedConversationReactionCount?.like ||
      activity.reaction_counts?.like ||
      0

    const ownReactions = (
      activity.startedConversationOwnReactions?.like ||
      activity.own_reactions?.like
    )?.filter((reaction) => !!reaction.id)

    queryClient.setQueryDefaults(queryKey, {
      gcTime: Infinity,
      staleTime: Infinity,
    })

    queryClient.setQueryData<CachedReaction>(queryKey, {
      reactionsCount,
      ownReactions: ownReactions || [],
      isLoading: false,
    })
  })
}
